import {TitleSummaryRequest} from '../../entity/model/title-summary-request';
import TitleSummaryRequestStore from '../store/title-summary-request-store';
import {TitleSummaryReportProps} from '../../entity/props/title/title-summary-report-props';
import {State} from '../../entity/model/state';
import {County} from '../../entity/model/county';
import {pdf} from '@react-pdf/renderer';
import React from 'react';
import TitleSummaryReportDocument from '../../app/layout/components/report/TitleSummaryReportDocument';
import { toast } from 'react-toastify';

export default class TitleSummaryRequestService {
    constructor(private titleSummaryRequestStore: TitleSummaryRequestStore) {}

    getTitleSummaryRequestDto = (): TitleSummaryRequest => {
        const props = this.titleSummaryRequestStore.currentProps;

        return {
            _id: props?.reportData?._id ?? crypto.randomUUID(),
            orderInformation: {
                orderNumber: props?.reportData?.orderInformation?.orderNumber ?? props?.project?.orderNumber,
                searchType: props?.reportData?.orderInformation?.searchType ?? props?.project?.searchType,
                searchStartDate: props?.reportData?.orderInformation?.searchStartDate,
                searchEndDate: props?.reportData?.orderInformation?.searchEndDate
            },
            propertyInformation: {
                stateID: props?.reportData?.propertyInformation?.stateID ?? props?.title?.stateID ?? props?.project?.stateID,
                countyID: props?.reportData?.propertyInformation?.countyID ?? props?.title?.countyID ?? props?.project?.countyID,
                propertyAddress: props?.reportData?.propertyInformation?.propertyAddress ?? props?.title?.address ?? props?.project?.address,
                parcelNumber: props?.reportData?.propertyInformation?.parcelNumber ?? props?.title?.tmsParcelNumbers?.[0],
                currentOwner: props?.reportData?.propertyInformation?.currentOwner ?? props?.project?.sellers
            },
            vestingDeeds: props?.reportData?.vestingDeeds ?? [],
            estates: props?.reportData?.estates ?? [],
            taxYears: props?.reportData?.taxYears ?? [],
            taxFlags: {
                pendingTaxSale: props?.reportData?.taxFlags?.pendingTaxSale ?? false,
                delinquentTaxes: props?.reportData?.taxFlags?.delinquentTaxes ?? false,
                rollBackTaxes: props?.reportData?.taxFlags?.rollBackTaxes ?? false,
                taxExempt: props?.reportData?.taxFlags?.taxExempt ?? false
            },
            mobileHome: props?.reportData?.mobileHome ?? [],
            mortgages: props?.reportData?.mortgages ?? [],
            judgments: props?.reportData?.judgments ?? [],
            liens: props?.reportData?.liens ?? [],
            uccs: props?.reportData?.uccs ?? [],
            restrictionsAgreements: props?.reportData?.restrictionsAgreements ?? [],
            easementsRightOfWays: props?.reportData?.easementsRightOfWays ?? [],
            comment: props?.reportData?.comment
        };
    }

    loadTitleSummaryRequests = async (organizationId: string, titleId: string): Promise<void> => {
        await this.titleSummaryRequestStore.loadTitleSummaryRequests(organizationId, titleId);
    }

    getTitleSummaryRequest = (documentId: string): TitleSummaryRequest | undefined => {
        return this.titleSummaryRequestStore.titleSummaryRequests.find((titleSummaryRequest: TitleSummaryRequest) => titleSummaryRequest.documentID === documentId);
    }

    loadSharedData = (): void => {
        this.titleSummaryRequestStore.loadSharedData();
    }

    getCurrentStateId = (): string => {
        const props = this.titleSummaryRequestStore.currentProps;
        return props?.title?.stateID ?? props?.project?.stateID ?? '';
    }

    getCurrentProps = (): TitleSummaryReportProps | undefined => {
        return this.titleSummaryRequestStore.currentProps;
    }

    setCurrentProps = (props: TitleSummaryReportProps | undefined): void => {
        this.titleSummaryRequestStore.setCurrentProps(props);
    }

    generateTitleSummaryReportPdf = async (titleSummaryRequest: TitleSummaryRequest, state?: State, county?: County): Promise<Blob> => {
        try {
            return await pdf(
                React.createElement(TitleSummaryReportDocument, {
                    titleSummaryRequest: titleSummaryRequest,
                    state: state,
                    county: county
                }) as any
            ).toBlob();
        } catch (error) {
            console.error('Error generating PDF report:', error);
            throw error;
        }
    }

    createTitleSummaryRequest = async (organizationId: string, titleSummaryRequest: TitleSummaryRequest): Promise<void> => {
        const result = await this.titleSummaryRequestStore.createTitleSummaryRequest(organizationId, { body: titleSummaryRequest });
        if (typeof result === 'string')
            toast.error(result);
        else
            toast.success('Title summary report uploaded successfully!');
    }

    updateTitleSummaryRequest = async (organizationId: string, titleSummaryRequestId: string, titleSummaryRequest: TitleSummaryRequest): Promise<void> => {
        const result = await this.titleSummaryRequestStore.updateTitleSummaryRequest(organizationId, titleSummaryRequestId, { body: titleSummaryRequest });
        if (typeof result === 'string')
            toast.error(result);
        else
            toast.success('Title summary report updated successfully!');
    }
}
